export enum ROUTE {
  // Authentication
  AUTHENTICATION = "/auth",
  LOGIN = `${ROUTE.AUTHENTICATION}/login`,

  // Authenticated app
  AUTHENTICATED = "/anzitutto",
  USERS = `${ROUTE.AUTHENTICATED}/users`,
  PROFILE = `${ROUTE.USERS}/profile`,
  USERS_ROLE_ADMIN = `${ROUTE.USERS}/role-admin`,
  USERS_ROLE_USER = `${ROUTE.USERS}/role-user`,
  ORGANIZATIONS = `${ROUTE.AUTHENTICATED}/organizations`,
  CENTERS = `${ROUTE.AUTHENTICATED}/centers`,
  EVENTS = `${ROUTE.AUTHENTICATED}/events`,
  CONTACTS = `${ROUTE.AUTHENTICATED}/contacts`
}
